import {
    RECEIVE_USER_PROFILE,
    REMOVE_USER_PROFILE,
    RECEIVE_USER_PROFILE_ERRORS, 
  } from '../actions/userProfile_actions';
  import { RECEIVE_USER_LOGOUT } from '../actions/session_actions'; // Import logout action type

  
  const initialState = {
    profile: null,
    errors: [],
  };
  
  const userProfileReducer = (state = initialState, action) => {
    switch (action.type) {
      case RECEIVE_USER_PROFILE:
        return { ...state, profile: action.profile, errors: [] };
      case REMOVE_USER_PROFILE:
        return { ...state, profile: null, errors: [] };
      case RECEIVE_USER_PROFILE_ERRORS:
        return { ...state, errors: action.errors };
      case RECEIVE_USER_LOGOUT: // Handle logout
        return initialState; // Reset state to initial
      default:
        return state;
    }
  };
  
  export default userProfileReducer;
  